import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import { isA, getStrValue, isReporter } from "../../store/utility";
import CellStatus from "../../components/UI/Widget/CellStatus";
import RequestContact from "../../components/UI/Widget/RequestContact";
import {
  updtRequest,
  fetchRequest,
  fetchContacts,
} from "../../store/actions/index";
import axios from "../../axios-atis";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import Loader from "react-loader-spinner";

import {
  Breadcrumb,
  Panel,
  FormGroup,
  Col,
  FormControl,
  Form,
  ControlLabel,
  Tabs,
  Tab,
  Button,
} from "react-bootstrap";

import RequestTab from "./Tab/RequestTab";
import PlanedTab from "./Tab/PlanedTab";
import InterventionTab from "./Tab/InterventionTab";
import { Redirect } from "react-router-dom";

class EditRequest extends React.Component {
  constructor(props) {
    super(props);
    var idLocale = require("moment/locale/fr");
    moment.locale("id", idLocale);

    this.state = {
      request: null,
      company: {},
      contacts: null,
      contactsForSend: null,
      canPlanned: false,
      plannedResume: null,
      interventionDate: null,
      interventionResume: null,
      requestId: null,
      loaded: true,
    };
  }

  //Lifecycle
  componentDidMount() {
    this.props.dispatch(fetchContacts());
    this.props.dispatch(fetchRequest(this.props.match.params.number));
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState({ requestId: nextProps.match.params.number });

    if (this.state.request !== nextProps.request) {
      this.setState({ request: nextProps.request });
    }
    if (this.state.contacts !== nextProps.contacts) {
      this.setState({ contacts: nextProps.contacts });
    }
    if (this.state.loaded !== nextProps.loaded) {
      this.setState({ loaded: nextProps.loaded });
    }
  }
  setContacts = (contacts) => {
    this.setState({ contactsForSend: contacts });
  };
  //Form Update
  changeRequestSection = (event, company) => {
    let { request } = this.state;
    const section = company.sections.find(section => section.label.trim() === event.target.value.trim())
    axios.post("/requests/" + request.id + "/sections/" + section.id)
      .then((response) => {
        if (response.status == 200)
          this.setState({ request: response.data }) ;
      })
      .catch(err => {});
    
  };
  //getContact
  getMyContacts = () => {
    const { contacts, contactsForSend } = this.state;
    let _contacts = [];
    let contactsSrc = contacts;

    if (contactsForSend !== null) {
      contactsSrc = contactsForSend;
    }
    
    for (let contactSrc of contactsSrc) {
      _contacts.push({ id: contactSrc.value, email: contactSrc.label });
    }

    return _contacts;
  };
  
  //Reponse
  updResponse = (updReq, files) => {
    updReq.contacts = this.getMyContacts();
    const data = new FormData();
    for (let f of files) {
      data.append("files", f);//files[i]);
    }
    const json = JSON.stringify(updReq);
    const blob = new Blob([json], { type: "application/json" });
    data.append("request", blob);
    
    this.props.dispatch(updtRequest(updReq.id, data));
    this.forceUpdate();
  };

  //Intervention
  updIntervention = (value, files) => {
    let { request } = this.state;
    request.status = 1;
    request.contacts = this.getMyContacts();
    request.executedAt = value.executedAt;
    const intervention = {
      interventionType: "INTERVENTION",
      resume: value.resume,
      createdAt: value.executedAt,
    };
    request.intervention = intervention;

    const data = new FormData();
    for (let f of files) {
      data.append("files", f);
    }

    const json = JSON.stringify(request);
    const blob = new Blob([json], { type: "application/json" });
    data.append("request", blob);
    
    this.props.dispatch(updtRequest(request.id, data));
    this.forceUpdate();
  };

  //Intervention
  changeInterventionDate = (selectedDate) => {
    this.setState({
      interventionDate: selectedDate,
    });
  };
  inputInterventionChangeHandler = (event) => {
    this.setState({
      interventionResume: event.target.value,
    });
  };
  validateIntervention = () => {
    return this.state.interventionDate != null;
  };
  buildOptions(company) {
    const sections = company.sections;
    if (company && company.sections) {
      sections.sort((a, b) => a.label.trim().localeCompare(b.label.trim(), "fr-FR"));
      return sections.map(function (section, index) {
        if (section.enabled)
          return (
            <option key={index} value={section.label}>
              {section.label}
            </option>
          );
        return null;
      });
    }
  }

  render() {
    var { request, contacts, loaded } = this.state;
    
    if (null === request || null === contacts || loaded) {
      return (
        <div align="center">
          <Loader type="ThreeDots" color="#00BFFF" height="100" width="100" />
        </div>
      );
    }
    var company = null;
    if (this.props.companies.filter((c) => c.name === request.company).length> 0) {
      company = this.props.companies.filter((c) => c.name === request.company)[0];
    }
    
    var requestContacts = contacts.filter(
      (c) => c.company.name === request.company
    );

    const canUpdate = (isA() || isReporter()) && request.status !== 2;
    const plannedDate =
      request.predictedAt !== null
        ? moment(request.predictedAt, "DD/MM/YYYY")
        : null;
    const interventionDate =
      request.executedAt !== null
        ? moment(request.executedAt, "DD/MM/YYYY")
        : null;
    if (request.status === 2) {
      return <Redirect to="/requests/" />;
    }
    return (
      <div className="content-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item href="/#/requests">Interventions</Breadcrumb.Item>
          <Breadcrumb.Item href={`/#/requests/${this.state.requestId}`}>
            Intervention n°{request.numRequest}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>&Eacute;dition</Breadcrumb.Item>
        </Breadcrumb>
        <Panel>
          <Panel.Body>
            <Form horizontal>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Titre
                </Col>
                <Col sm={10}>
                  <FormControl
                    type="text"
                    value={getStrValue(request.name)}
                    className="form-control"
                    disabled
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Société
                </Col>
                <Col sm={4}>
                  <FormControl
                    type="text"
                    value={getStrValue(request.company)}
                    className="form-control"
                    disabled
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={2}>
                  Site
                </Col>
                <Col sm={4}>
                  <FormControl
                      componentClass="select"
                      placeholder="Site"
                      id="section"
                      onChange={(event) => this.changeRequestSection(event, company)}
                      value={request.section}
                    >
                      <option value="" />
                      {this.buildOptions(company)}
                    </FormControl>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Créée le
                </Col>
                <Col sm={4}>
                  <FormControl
                    type="text"
                    value={getStrValue(request.createdAt)}
                    className="form-control"
                    disabled
                  />
                </Col>
                <Col componentClass={ControlLabel} sm={2}>
                  Statut
                </Col>
                <Col sm={2} style={{ paddingTop: "5px" }}>
                  <CellStatus
                    requestStatus={request.status}
                    fontSize="1em"
                    align="left"
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={2}>
                  Envoyé à
                </Col>
                <Col sm={10}>
                  <RequestContact
                    contacts={requestContacts}
                    requestContacts={request.contacts}
                    setContacts={(value) => this.setContacts(value)}
                    canUpdate={canUpdate}
                  />
                </Col>
              </FormGroup>
            </Form>

            <Tabs id="wf-tab" defaultActiveKey={null !== plannedDate ? 3 : 2}>
              <Tab eventKey={1} title="Demande">
                <RequestTab requestResume={request.request} />
              </Tab>
              {null !== plannedDate || canUpdate ? (
                <Tab eventKey={2} title="Planification">
                  <PlanedTab
                    request={request}
                    canUpdate={canUpdate}
                    updResponse={(value, files) => this.updResponse(value, files)}
                  />
                </Tab>
              ) : null}
              {interventionDate !== null ||
              (null !== plannedDate && canUpdate) ? (
                <Tab eventKey={3} title="Intervention">
                  <InterventionTab
                    request={request}
                    canUpdate={canUpdate}
                    updIntervention={(value, files) => this.updIntervention(value, files)}
                  />
                </Tab>
              ) : null}
            </Tabs>
          </Panel.Body>
        </Panel>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    error: state.contact.error,
    loaded: state.contact.loading || state.request.loading,
    company: state.auth.company,
    contacts: state.contact.contacts,
    companies: state.company.companies,
    request: state.request.request,
  };
};

export default connect(mapStateToProps)(withErrorHandler(EditRequest, axios));



// WEBPACK FOOTER //
// ./src/containers/Request/EditRequest.js